import React from "react";
import { BoxInput } from "../../types/form";

type BoxesFormProps = {
    inputs: BoxInput[];
    onChange: (next: BoxInput[]) => void;
};

export const BoxesForm: React.FC<BoxesFormProps> = ({ inputs, onChange }) => {
    const update = (idx: number, patch: Partial<BoxInput>) => {
        const next = inputs.map((x, i) => (i === idx ? { ...x, ...patch } : x));
        onChange(next);
    };

    const addRow = () => {
        onChange([...inputs, { length: 0, width: 0, height: 0, amount: 0 }]);
    };

    const removeRow = (idx: number) => {
        const next = inputs.filter((_, i) => i !== idx);
        onChange(next.length ? next : [{ length: 0, width: 0, height: 0, amount: 0 }]);
    };

    const toNumber = (v: string) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

    return (
        <div className="calculator-boxes">
            <div className="calculator-boxes-head">
                <div className="calculator-section-title">Коробки</div>
            </div>

            <div className="calculator-boxes-table">
                <div className="calculator-boxes-row calculator-boxes-row--header">
                    <div>Длина, см</div>
                    <div>Ширина, см</div>
                    <div>Высота, см</div>
                    <div>Кол-во</div>
                    <div />
                </div>

                {inputs.map((it, idx) => (
                    <div className="calculator-boxes-row" key={idx}>
                        <input
                            className="calculator-input"
                            type="number"
                            min={0}
                            inputMode="decimal"
                            placeholder="0"
                            value={it.length || ""}
                            onChange={(e) => update(idx, { length: toNumber(e.target.value) })}
                        />
                        <input
                            className="calculator-input"
                            type="number"
                            min={0}
                            inputMode="decimal"
                            placeholder="0"
                            value={it.width || ""}
                            onChange={(e) => update(idx, { width: toNumber(e.target.value) })}
                        />
                        <input
                            className="calculator-input"
                            type="number"
                            min={0}
                            inputMode="decimal"
                            placeholder="0"
                            value={it.height || ""}
                            onChange={(e) => update(idx, { height: toNumber(e.target.value) })}
                        />
                        <input
                            className="calculator-input"
                            type="number"
                            min={0}
                            inputMode="numeric"
                            placeholder="0"
                            value={it.amount || ""}
                            onChange={(e) => update(idx, { amount: toNumber(e.target.value) })}
                        />

                        <button
                            type="button"
                            className="calculator-icon-btn calculator-icon-btn--danger"
                            onClick={() => removeRow(idx)}
                            aria-label="Удалить строку"
                            title="Удалить"
                            disabled={inputs.length === 1}
                        >
                            ✕
                        </button>
                    </div>
                ))}
            </div>

            <div className="calculator-boxes-actions">
                <button type="button" className="calculator-add-btn" onClick={addRow}>
                    + Добавить коробку
                </button>
            </div>
        </div>
    );
};